import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class JobTypeService extends BaseService {
  constructor(protected override http: HttpClient) {
    super(http, `${environment.apiBaseUrl}/job_types`);
  }

  listActions(jobTypeId?: string): Observable<string[]> {
    const apiParams: any = {};
    if (jobTypeId) apiParams.job_type_id = jobTypeId;
    return this.http.get<string[]>(`${environment.apiBaseUrl}/job_types/actions`, {
      params: this.toHttpParams(apiParams),
    });
  }
}
